import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { NS } from '@/screens/Service/ducks/reducer';
import {
  getPublishedOpenApiSpec,
  updateCrumbs
} from '@/screens/Service/ducks/actions';

import { PublishedPage } from '../../components/PublishedPage';
import { PublishedSwagger } from '../../components/PublishedSwagger';

export const PublishedApiDoc = props => {
  const { updateCrumbs } = props;
  useEffect(() => {
    updateCrumbs([
      {
        label: 'Open API Specs',
        path: `/services/${props.service.get('handle')}/open-api-specs`
      },
      { label: 'Open API Spec' }
    ]);
  }, []);
  return <PublishedSwagger language="yml" {...props} />;
};

const mapStateToProps = state => ({
  service: state.getIn([NS, 'service']),
  publishedPage: state.getIn([NS, 'publishedOpenApiSpec']),
  pending: state.getIn([NS, 'pending', 'publishedOpenApiSpec']),
  canEdit: state.getIn([NS, 'team', 'is_member'], false)
});
const mapDispatchToProps = dispatch => ({
  getPublishedPage: pageId => dispatch(getPublishedOpenApiSpec(pageId)),
  updateCrumbs: crumbs => dispatch(updateCrumbs(crumbs))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PublishedApiDoc);
